// extracted by mini-css-extract-plugin
module.exports = {"selectContainer":"SelectSort_selectContainer__1Lz7s","small":"SelectSort_small__1kPF0"};